// useTheme.js
import { useEffect, useState } from 'react';

export const useTheme = (
    initialTheme: string = 'Light',
): [string, React.Dispatch<React.SetStateAction<string>>] => {
    const [theme, setTheme] = useState<string>(initialTheme);

    useEffect(() => {
        // Only run on the client-side (browser) to avoid SSR issues
        if (typeof window !== 'undefined') {
            // Retrieve the theme from localStorage if it exists
            const storedTheme = localStorage.getItem('theme');
            if (storedTheme) {
                setTheme(storedTheme);
            }

            // Function to update the theme based on a custom event
            const handleThemeChange = (event: CustomEvent<string>) => {
                setTheme(event.detail);
            };

            // Listen for custom theme changes (with correct typing)
            window.addEventListener('themeChanged', handleThemeChange as EventListener);

            // Clean up the event listener when the component is unmounted
            return () => {
                window.removeEventListener('themeChanged', handleThemeChange as EventListener);
            };
        }
    }, []); // Empty dependency array means this effect only runs once on mount

    return [theme, setTheme];
};
